import { Injectable } from '@angular/core';
import { SetInitialStateFacade } from '../../../../../common/models';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ServerMessagesState } from './server-messages.state';
import {
  ServerMessagesDisconnect,
  ServerMessagesInitialState,
  ServerMessagesHubTopic,
  ServerMessagesLoadTopic,
  ServerMessagesRemoveAllocateUliAfterCreationMessage,
  ServerMessagesUnsubscribeFromTopic,
  ServerMessagesSetUpConnection,
  ServerMessagesUliTopic,
  ServerMessagesRemoveUliAutoAllocationMessage,
} from './server-messages.actions';
import {
  HubTopicParamsModel,
  LoadTopicParamsModel,
  UliCreatedAndAllocatedServerMessageModel,
  UliCreateServerMessageModel,
  UliTopicParamsModel,
} from './models/server-messages.model';
import { TopicsEnum } from './constants';

@Injectable({
  providedIn: 'root',
})
export class ServerMessagesFacade implements SetInitialStateFacade {
  highlightedUli$: Observable<UliCreateServerMessageModel> = this.store.select(ServerMessagesState.getHighlightedUli);
  loadTopicMessages$: Observable<UliCreateServerMessageModel[]> = this.store.select(
    ServerMessagesState.getLoadTopicMessages,
  );
  uliTopicMessages$: Observable<UliCreatedAndAllocatedServerMessageModel[]> = this.store.select(
    ServerMessagesState.getUliTopicMessages,
  );
  totalUnreadMessagesNumber$: Observable<number> = this.store.select(ServerMessagesState.getTotalUnreadMessagesNumber);

  constructor(private store: Store) {}

  setUpConnection(): void {
    this.store.dispatch(new ServerMessagesSetUpConnection());
  }

  disconnect(): void {
    this.store.dispatch(new ServerMessagesDisconnect());
  }

  subscribeToHubTopic(params: HubTopicParamsModel): void {
    this.store.dispatch(new ServerMessagesHubTopic(params));
  }

  subscribeToLoadTopic(params: LoadTopicParamsModel): void {
    this.store.dispatch(new ServerMessagesLoadTopic(params));
  }

  subscribeToUliTopic(params: UliTopicParamsModel): void {
    this.store.dispatch(new ServerMessagesUliTopic(params));
  }

  unsubscribeFromTopic(topic: TopicsEnum): void {
    this.store.dispatch(new ServerMessagesUnsubscribeFromTopic(topic));
  }

  removeLoadMessage(uli: string): void {
    this.store.dispatch(new ServerMessagesRemoveAllocateUliAfterCreationMessage(uli));
  }

  removeUliMessage(uli: string): void {
    this.store.dispatch(new ServerMessagesRemoveUliAutoAllocationMessage(uli));
  }

  setInitialState(): void {
    this.store.dispatch(new ServerMessagesInitialState());
  }
}
